<template>
    <v-chip-group v-model="query['employment.types']" show-arrows center-active class="mb-40 mb-lg-80" @change="push">
        <template v-for="{ text, value } in items">
            <v-chip :key="value" v-bind="{ value }" x-large class="justify-center" active-class="primary"> {{ text }}</v-chip>
        </template>
    </v-chip-group>
</template>

<script>
import { EMPLOYMENT_TYPES } from "@/assets/variables";

const initQuery = (query = {}) => {
    query = { ...query };

    query["employment.types"] = query["employment.types"] || null;

    return { ...query };
};

const items = [{ text: "전체", value: null }].concat(Object.values(EMPLOYMENT_TYPES));

export default {
    data: () => ({
        loading: false,

        query: initQuery(),

        items,
    }),
    mounted() {
        this.init();
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
            } finally {
                this.loading = false;
            }
        },

        async sync() {
            this.query = initQuery(this.$route.query);
        },

        async push() {
            let { ...query } = this.$route.query;

            delete query.page;

            if (this.query["employment.types"]) {
                if (this.query["employment.types"] == query["employment.types"]) {
                    delete query["employment.types"];
                } else {
                    query["employment.types"] = this.query["employment.types"];
                }
            } else {
                delete query["employment.types"];
            }

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-slide-group__wrapper{
        margin: 0 12px;
    }
    .v-slide-group__content{
        justify-content: center;
        .v-chip {
            padding: 0 20px;
            margin: 0 6px 0 0;
            border-radius: 10px;
            height: 44px;
            font-size: 1.4rem;
            font-weight: 500;
            background-color: #f5f5f5;
        }
        .v-chip.primary{
            font-weight: 700;
        }
        .v-chip:last-child{
            margin: 0;
        }
    }    
    .v-slide-group__next, .v-slide-group__prev {
        flex: 0 1 44px;
        min-width: 44px;
        border-radius: 50%;
        border: 1px solid var(--v-primary-base);
        transition: 0.1s ease-out;
        background-size: 12px 16px;
        background-position: center;
        background-repeat: no-repeat;
    }
    .v-slide-group__next{
        background-image: url(/images/icon/icon-right-arrow-primary.svg);
    }
    .v-slide-group__prev{
        background-image: url(/images/icon/icon-left-arrow-primary.svg);
    }
    .v-slide-group__next--disabled,
    .v-slide-group__prev--disabled{
        opacity: 0.4;
    }
    .v-slide-group__prev i.v-icon.mdi.mdi-chevron-left,
    .v-slide-group__next i.v-icon.mdi.mdi-chevron-right{
        display: none;        
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    ::v-deep {
        .v-slide-group__content{
            .v-chip {
                min-width: 180px;
            }
        }
    }
}
@media (min-width:1024px){
    ::v-deep {
        .v-slide-group__wrapper{
            margin: 0 24px;
        }
        .v-slide-group__content{
            .v-chip {
                min-width: 236px;
                margin: 0 10px 0 0;
                border-radius: 20px;
                height: 56px;
                font-size: 1.8rem;
            }
            .v-chip:last-child{
                margin: 0;
            }
        }   
        .v-slide-group__next, .v-slide-group__prev {
            flex: 0 1 56px;
            min-width: 56px;
        }
    }
}
@media (min-width:1200px){
}

</style>
